'use client';

import { useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';

/**
 * Fires a Meta Pixel PageView on client-side (soft) navigations. The base snippet in
 * `app/layout.tsx` only fires PageView on the initial hard load, so without this a
 * visitor who lands on /comix/... and then clicks to the homepage never records a
 * homepage view. Skips the first render — the base snippet already counted it.
 */
export default function MetaPixelPageViews() {
  const pathname = usePathname();
  const lastPath = useRef<string | null>(null);

  useEffect(() => {
    if (lastPath.current === null) {
      lastPath.current = pathname;
      return;
    }
    if (lastPath.current === pathname) return;
    lastPath.current = pathname;
    const fbq = (window as Window & { fbq?: (...args: unknown[]) => void }).fbq;
    if (typeof fbq === 'function') fbq('track', 'PageView');
  }, [pathname]);

  return null;
}
